import React from 'react';
import './index.css';
import { Snackbar, Alert } from '@mui/material';

export const SnackMsg = ({ msg="", show=false, onClose=null }) => {
    return (
        <Snackbar open={show} autoHideDuration={4000} onClose={onClose}>
            <Alert 
                elevation={6} 
                iconMapping={{}} // equivalent to icon={false} in v5/v6
                onClose={onClose} 
                sx={styles.alert}
            >
                {msg}
            </Alert>
        </Snackbar>
    );
}

const styles = {
    alert: {
        color: '#ced1d9',
        backgroundColor: '#0d1943'
    }
}